import { useCallback, useState } from 'react';
import { downloadAdminExport, downloadAdminExportPeriod, ExportPeriodParams } from '../api/admin.api';

export type ExportType = 'all' | 'active' | 'no_orders' | 'repeat';
export type ExportFormat = 'csv' | 'xlsx';

export function useAdminExport() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const downloadByMonth = useCallback(async (month: string) => {
    if (!/^\d{4}-\d{2}$/.test(month)) {
      setError('Укажите месяц ГГГГ-ММ');
      return;
    }
    setError(null);
    setLoading(true);
    try {
      const blob = await downloadAdminExport(month);
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `clients_${month.replace('-', '_')}.csv`;
      a.click();
      URL.revokeObjectURL(url);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Ошибка загрузки');
    } finally {
      setLoading(false);
    }
  }, []);

  const downloadByPeriod = useCallback(async (params: ExportPeriodParams) => {
    setError(null);
    setLoading(true);
    try {
      const blob = await downloadAdminExportPeriod(params);
      const ext = params.format === 'xlsx' ? 'xlsx' : 'csv';
      const name = `clients_${params.from.replace(/-/g, '_')}_${params.to.replace(/-/g, '_')}.${ext}`;
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = name;
      a.click();
      URL.revokeObjectURL(url);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Ошибка загрузки');
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    loading,
    error,
    downloadByMonth,
    downloadByPeriod,
  };
}
